<template>
  <div :class="{ loading }" class="template-container">
    <router-view />
    <b-loading
      :is-full-page="true"
      v-model="loading"
      :can-cancel="true"
    ></b-loading>
  </div>
</template>

<script>
//import SocketioService from "./services/socketio.service";
export default {
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  sockets: {
    connect() {
      // Fired when the socket connects.
      this.$store.commit("isConnected", true);
    },
    disconnect() {
      // Fired when the socket disconnect.
      this.$store.commit("isConnected", false);
    },
  },
  created() {
    /*SocketioService.setupSocketConnection();
    SocketioService.socket.on("connect", () => {
      this.$store.commit("isConnected", true);
      console.log("conected");
    });
    SocketioService.socket.on("disconnect", (reason) => {
      this.$store.commit("isConnected", false);
      if (reason === "io server disconnect") {
        // the disconnection was initiated by the server, you need to reconnect manually
        SocketioService.socket.connect();
      }
      // else the socket will automatically try to reconnect
    });*/
  },
  beforeUnmount() {
    //SocketioService.disconnect();
  },
  methods: {
    logout() {
      this.$store.commit("user");
      window.location.replace("/");
    },
    //chat
    /*broadcast() {
      this.sockets.subscribe(this.terminal.key, (data) => {
        this.calls.push(data);
      });
    },*/
  },
};
</script>
